import { cn, isCreditCardExpired } from '@/lib/utils';
import React from 'react';
import { Text } from '@radix-ui/themes';
import { TokenizedPM } from '@/lib/interface/stripe/tokenizedCard';
import { BiddifyPaymentMethod, MinimalCard } from '@/lib/interface/stripe/BiddifyPaymentMethod';

const CreditCardSelectExpiryText = ({ card }: { card: MinimalCard }) => {
  const isExpired = isCreditCardExpired(card);
  const formattedMonth = card.exp_month?.toString().padStart(2, '0');
  const displayText = isExpired ? 'Expired' : 'Expires';
  return (
    <Text className={cn(
      "text-sm",
      isExpired ?
        "text-red-400" :
        "font-light text-gray-400"
    )}>{`${displayText} ${formattedMonth}/${card.exp_year}`}</Text>
  );
}

export default CreditCardSelectExpiryText
